export enum NetboxStatus {
  Disabled = 0,
  Idle = 1,
  Active = 2,
}
